<div class="pointer-events-auto h-full w-full" *ngIf="selectedFilterModule && isLoaded">
    <div class="flex flex-col-1 h-full w-full dispatch-filter-panel" [ngClass]="{
        'filter-footer-available': filterOptions?.footer?.enabled !== false && !hideSaveFilter, 'filter-footer-available-without-save': filterOptions?.footer?.enabled !== false && hideSaveFilter}">
        <!-- Sidenav -->
        <div class="dispatch-filter-sidenav w-20 h-full bg-white border-r border-gray-300">
            <ul>
                <li *ngFor="let module of filterModuleTabs">
                    <button class="w-full border-b border-gray-300 border-solid h-20" *ngIf="module.showIf"
                        [ngClass]="{'tab-icon-selected': module.moduleKey === selectedFilterModule.moduleKey, 'text-gray-600': module.moduleKey !== selectedFilterModule.moduleKey}"
                        (click)="onTabChange(module); dispatchBoardService.trackEvent('filter_' + module.moduleKey)">
                        <ng-conatiner *ngIf="module.moduleKey === 'GRID'" title="{{'text.dispatchers_queue' | translate}}">
                            <svg id="briefcase" class="w-9 m-auto" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24" fill="currentColor">
                                <path fill-rule="evenodd"
                                    d="M7.5 5.25a3 3 0 013-3h3a3 3 0 013 3v.205c.933.085 1.857.197 2.774.334 1.454.218 2.476 1.483 2.476 2.917v3.033c0 1.211-.734 2.352-1.936 2.752A24.726 24.726 0 0112 15.75c-2.73 0-5.357-.442-7.814-1.259-1.202-.4-1.936-1.541-1.936-2.752V8.706c0-1.434 1.022-2.7 2.476-2.917A48.814 48.814 0 017.5 5.455V5.25zm7.5 0v.09a49.488 49.488 0 00-6 0v-.09a1.5 1.5 0 011.5-1.5h3a1.5 1.5 0 011.5 1.5zm-3 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z"
                                    clip-rule="evenodd" />
                                <path
                                    d="M3 18.4v-2.796a4.3 4.3 0 00.713.31A26.226 26.226 0 0012 17.25c2.892 0 5.68-.468 8.287-1.335.252-.084.49-.189.713-.311V18.4c0 1.452-1.047 2.728-2.523 2.923-2.12.282-4.282.427-6.477.427a49.19 49.19 0 01-6.477-.427C4.047 21.128 3 19.852 3 18.4z" />
                            </svg>
                        </ng-conatiner>
                        <ng-conatiner *ngIf="module.moduleKey === 'EMPLOYEE'" title="{{'text.users' | translate}}">
                            <svg id="user" class="w-9 m-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                fill="currentColor">
                                <path fill-rule="evenodd"
                                    d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z"
                                    clip-rule="evenodd" />
                            </svg>
                        </ng-conatiner>
                        <ng-conatiner *ngIf="module.moduleKey === 'SCHEDULER'" title="{{'dispatchBoard.settings.scheduler.title' | translate}}">
                            <svg id="calendar" class="w-9 m-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                fill="currentColor">
                                <path fill-rule="evenodd"
                                    d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                    clip-rule="evenodd" />
                            </svg>
                        </ng-conatiner>
                        <ng-conatiner *ngIf="module.moduleKey === 'MAP'" title="{{'dispatchBoard.settings.map.title' | translate}}">
                            <svg id="map" class="w-9 m-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                fill="currentColor">
                                <path fill-rule="evenodd"
                                    d="M8.161 2.58a1.875 1.875 0 011.678 0l4.993 2.498c.106.052.23.052.336 0l3.869-1.935A1.875 1.875 0 0121.75 4.82v12.485c0 .71-.401 1.36-1.037 1.677l-4.875 2.437a1.875 1.875 0 01-1.676 0l-4.994-2.497a.375.375 0 00-.336 0l-3.868 1.935A1.875 1.875 0 012.25 19.18V6.695c0-.71.401-1.36 1.036-1.677l4.875-2.437zM9 6a.75.75 0 01.75.75V15a.75.75 0 01-1.5 0V6.75A.75.75 0 019 6zm6.75 3a.75.75 0 00-1.5 0v8.25a.75.75 0 001.5 0V9z"
                                    clip-rule="evenodd" />
                            </svg>
                        </ng-conatiner>
                    </button>
                </li>
            </ul>
        </div>
        <div class="dispatch-filter-fields h-full w-full bg-white relative">
            <!-- Filter Header -->
            <div class="p-4 border-b dispatch-filter-header-container">
                <div class="flex items-start justify-between">
                    <div class="flex items-center">
                        <h2 class="text-xl font-semibold primary-font">
                            {{(selectedFilterModule?.headerDisplayKey | translate) ??
                            selectedFilterModule?.headerDisplayName}}</h2>
                    </div>
                    <div class="ml-auto flex h-7 items-center" *ngIf="filterOptions?.showCloseIcon !== false">
                        <div class="flex flex-shrink-0 ml-auto cursor-pointer rounded-full w-10 h-10 hover:bg-gray-200 items-center justify-center -mr-1"
                            (click)="closeFilterPanel()">
                            <em class="ti ti-x text-xl"></em>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Filter Body -->
            <div class="dispatch-filter-body-container overflow-y-auto overflow-x-hidden zuper-scrollbar">
                <!-- Filter - GRID -->
                <div *ngIf="selectedFilterModule.moduleKey === 'GRID'">
                    <div *ngIf="currentTab === 'ROUTES'">
                        <p class="text-lg font-semibold primary-font p-4 pb-0">{{'text.route' | translate}}</p>
                        <dispatch-advanced-filter [dispatchTab]="currentTab" [additionalFilters]="additionalFilters" [module]="'grid_route'"
                            [filterOptionalValues]="appliedFilter.grid_route"
                            (applyOrSaveFilter)="applyOrSaveFilter($event)"></dispatch-advanced-filter>
                        <p class="text-lg font-semibold primary-font p-4 pb-0">{{'job' | translate}}</p>
                    </div>
                
                    <div>
                        <dispatch-advanced-filter [dispatchTab]="currentTab" [additionalFilters]="additionalFilters" [module]="'grid'"
                            [filterOptionalValues]="appliedFilter.grid"
                            (applyOrSaveFilter)="applyOrSaveFilter($event)"></dispatch-advanced-filter>
                    </div>
                </div>
                <!-- Filter - EMPLOYEE -->
                <div *ngIf="selectedFilterModule.moduleKey === 'EMPLOYEE'">
                    <dispatch-advanced-filter [dispatchTab]="currentTab" [additionalFilters]="additionalFilters" [module]="'employee'"
                        [filterOptionalValues]="appliedFilter.employee"
                        (applyOrSaveFilter)="applyOrSaveFilter($event)"></dispatch-advanced-filter>
                </div>
                <!-- Filter - SCHEDULER -->
                <div *ngIf="selectedFilterModule.moduleKey === 'SCHEDULER'">
                    <form class="primary-font" autocomplete="off" [formGroup]="scheduleFilterForm">
                        <ng-container *ngIf="currentTab === 'ROUTES'">
                            <p class="text-lg font-semibold primary-font p-4 pb-0">{{'text.route' | translate}}</p>
                            <dispatch-advanced-filter [dispatchTab]="currentTab" [additionalFilters]="additionalFilters" [module]="'scheduler_route'"
                                [filterOptionalValues]="appliedFilter.scheduler_route"
                                (applyOrSaveFilter)="applyOrSaveFilter($event)"></dispatch-advanced-filter>
                            <p class="text-lg font-semibold primary-font p-4 pb-0">{{'job' | translate}}</p>
                        </ng-container>
                        <dispatch-advanced-filter [dispatchTab]="currentTab" [additionalFilters]="additionalFilters" [module]="'scheduler'"
                            [filterOptionalValues]="appliedFilter.scheduler"
                            (applyOrSaveFilter)="applyOrSaveFilter($event)"></dispatch-advanced-filter>
                    </form>
                </div>
                <!-- Filter - MAP -->
                <div *ngIf="selectedFilterModule.moduleKey === 'MAP'" class="p-4">
                    <form class="primary-font" autocomplete="off" [formGroup]="mapFilterForm">
                        <!-- Routes -->
                        <div class="mb-4">
                            <label class="block text-base mb-2 font-medium text-gray-600">
                                {{'text.route' | translate}}
                            </label>
                            <ng-select class="job-route-filter" [items]="mapRoutes | async" formControlName="route" (search)="onMapRouteSearch()" 
                                bindLabel="route_name" bindValue="route_uid" [loading]="mapRouteFetching" [multiple]="true"
                                [typeahead]="mapRouteValueSubject" (clear)="onMapRouteClear()" (scrollToEnd)="onMapRouteScrollToEnd()"
                                appendTo="body" [hideSelected]="true"
                                placeholder="{{'text.search_route' | translate}}">
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    <div class="primary-font text-base flex flex-col">
                                        <p class="font-medium">
                                            {{item.route_name}}
                                        </p>
                                        <p>
                                            {{item.departure | datetime}}
                                        </p>
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <!-- Filter Footer -->
    <div class="dispatch-filter-footer-container border-t border-gray-100 w-full px-3 py-3.5 space-y-4"
        *ngIf="filterOptions?.footer?.enabled !== false">
        <div class="w-full px-4 flex justify-center" *ngIf="!hideSaveFilter">
            <div class="w-full flex items-center space-x-2">
                <input class="cursor-pointer" type="checkbox" [(ngModel)]="saveAsFilter" id="calendar_save_filter" />
                <label for="calendar_save_filter" class="cursor-pointer text-base">
                    {{'dispatch.filter.footer.save_as.filter' | translate}}</label>
            </div>
        </div>
        <div class="w-full px-4 flex justify-between gap-4">
            <button mat-stroked-button (click)="resetFilterPanel()"
                class="h-10 min-h-10 px-6 w-full items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">
                {{'reset.text' | translate}}
            </button>
            <button type="button" (click)="applyFilter()"
                class="bg-primary w-full px-4 h-10 items-center py-2 border-gray-300 shadow-sm text-white text-base font-medium rounded-md text-white-600 focus:outline-none">
                {{'text.apply' | translate}}
            </button>
        </div>
    </div>
</div>
<div *ngIf="!isLoaded" class="flex justify-center items-center h-full">
    <lazy-loader></lazy-loader>
</div>